import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-background-dark py-32 px-8 md:px-24">
      <div className="mb-24">
        <h4 className="text-[15vw] md:text-[18vw] font-display tracking-tighter uppercase leading-[0.75] text-white">
          THE
          <br />
          REALESTT
        </h4>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-12 border-t border-white/10 pt-16">
        <div className="md:col-span-2">
          <p className="text-sm text-body-grey/60 max-w-xs leading-relaxed uppercase tracking-widest text-[10px]">
            Available on all streaming platforms. Stay tuned for what's next.
            The journey continues.
          </p>
        </div>

        <div>
          <h5 className="text-[10px] uppercase tracking-[0.4em] font-bold mb-8 text-white">
            Navigation
          </h5>
          <ul className="space-y-4 text-xs uppercase tracking-widest text-body-grey">
            <li>
              <Link className="hover:text-primary transition-colors" to="/">
                Home
              </Link>
            </li>
            <li>
              <Link
                className="hover:text-primary transition-colors"
                to="/about"
              >
                About
              </Link>
            </li>
            <li>
              <Link
                className="hover:text-primary transition-colors"
                to="/discography"
              >
                Discography
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h5 className="text-[10px] uppercase tracking-[0.4em] font-bold mb-8 text-white">
            Socials
          </h5>
          <ul className="space-y-4 text-xs uppercase tracking-widest text-body-grey">
            <li>
              <a
                className="hover:text-primary transition-colors"
                target="_blank"
                href="https://www.instagram.com/therealestt_77?igsh=MWRrOTdiMWpvY20zMg%3D%3D&utm_source=qr"
              >
                Instagram
              </a>
            </li>
            <li>
              <a
                className="hover:text-primary transition-colors"
                target="_blank"
                href="https://www.facebook.com/share/1DYTtHrMgc/?mibextid=wwXIfr"
              >
                Facebook
              </a>
            </li>
            <li>
              <a
                className="hover:text-primary transition-colors"
                target="_blank"
                href="https://www.tiktok.com/@therealest_junny?_r=1&_t=ZS-94PVHrXkVK1"
              >
                TikTok
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="mt-32 flex flex-col md:flex-row justify-between items-center text-[10px] uppercase tracking-[0.3em] text-white/60 border-t border-white/5 pt-8">
        <p>© {new Date().getFullYear()} THEREALESTT STUDIO</p>
        <p>ESTABLISHED IN THE UNDERGROUND</p>
      </div>
    </footer>
  );
}
